import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import useUpdateQuantity from './UpdateQuantity';
import useRemoveItem from './RemoveItem';
import { useCart } from './CartContext';
import { RiDeleteBinLine } from "react-icons/ri";
import './Cart.css';
import BASE_URL, { getImageURL } from '../config';
const Cart = () => {
  const navigate = useNavigate();
  const { cart, loading, error, fetchCart } = useCart();
  const { handleUpdateQuantity, loading: updating, error: updateError } = useUpdateQuantity(fetchCart);
  const { handleRemoveItem, loading: removing, error: removeError } = useRemoveItem(fetchCart);

  const handleCheckout = () => {
    const checkoutData = {
      items: cart.items,
      total_price: cart.total_price,
    };
    localStorage.setItem('checkoutdata', JSON.stringify(checkoutData));
    navigate('/checkout', { state: checkoutData });
  };

  if (!cart?.items || cart.items.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-empty">
          <p className="cart-empty-text">Your cart is empty</p>
          <a href="/products" className="cart-empty-link">Browse products</a>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-header">
        <h1>Your Cart</h1>
        <a href="/products" className="cart-continue-link">← Continue shopping</a>
      </div>

      {updateError && <p className="cart-error">{updateError}</p>}

      {/* Table header */}
      <div className="cart-table-header">
        <span className="cart-col-label">Product</span>
        <span className="cart-col-label center">Quantity</span>
        <span className="cart-col-label right">Total</span>
      </div>

      {/* Cart items */}
      {cart.items.map((cartItem) => (
        <div className="cart-item-row" key={cartItem.id}>
          <div className="cart-item-product">
            <img
              className="cart-item-image"
              src={cartItem.item.mainimage ? getImageURL(cartItem.item.mainimage) : 'placeholder.jpg'}
              alt={cartItem.item.title}
            />
            <div className="cart-item-details">
              <p className="cart-item-title">{cartItem.item.title}</p>
              <span className="cart-item-unit-price">CHF {(parseFloat(cartItem.item.discount_price) || parseFloat(cartItem.item.price) || 0).toFixed(2)}</span>
            </div>
          </div>

          <div className="cart-qty-controls">
            <button
              className="cart-qty-btn"
              onClick={() => handleUpdateQuantity(cartItem.item.slug, cartItem.quantity - 1)}
              disabled={updating || cartItem.quantity <= 1}
            >−</button>
            <span className="cart-qty-value">{cartItem.quantity}</span>
            <button
              className="cart-qty-btn"
              onClick={() => handleUpdateQuantity(cartItem.item.slug, cartItem.quantity + 1)}
              disabled={updating}
            >+</button>
            <button
              className="cart-remove-btn"
              onClick={() => handleRemoveItem(cartItem.item.slug)}
              disabled={removing}
            >
              <RiDeleteBinLine />
            </button>
          </div>

          <span className="cart-item-total">
            CHF {(cartItem.quantity * (parseFloat(cartItem.item.discount_price) || parseFloat(cartItem.item.price) || 0)).toFixed(2)}
            {parseFloat(cartItem.item.shipping_price) > 0 && (
              <span className="cart-item-shipping">+CHF {parseFloat(cartItem.item.shipping_price).toFixed(2)} shipping</span>
            )}
          </span>
        </div>
      ))}

      {/* Footer */}
      <div className="cart-footer">
        {/* Free shipping progress */}
        {cart.total_price < 80 ? (
          <div className="cart-free-shipping-banner">
            <span>🚚 Free shipping from CHF 80.– – only CHF {(80 - cart.total_price).toFixed(2)} to go!</span>
            <div className="cart-shipping-progress-bar">
              <div className="cart-shipping-progress-fill" style={{ width: `${Math.min((cart.total_price / 80) * 100, 100)}%` }}></div>
            </div>
          </div>
        ) : (
          <div className="cart-free-shipping-banner free">
            <span>✅ You qualify for free shipping!</span>
          </div>
        )}

        <span className="cart-total-price">Total: CHF {cart.total_price.toFixed(2)}</span>
        <span className="cart-total-note">Final price will be calculated at checkout</span>
        <button
          className="cart-checkout-btn"
          onClick={handleCheckout}
          disabled={loading}
        >
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
};

export default Cart;